"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledEllipsisContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledEllipsisContainer = styled_components_1.default.div `
  width: ${({ width }) => width};
  overflow: hidden;
  white-space: pre-line;

  & > p {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: ${({ maxRows }) => maxRows};
    -webkit-box-orient: vertical;
    margin: 0;
  }
`;
